// extracted by mini-css-extract-plugin
export default {"linkStyleCopy":"C7-z"};